export default "__VITE_ASSET__CzSYIypl__"